import Swiper from 'swiper';
import debounce from '../utils/debounce';
const specialOffers = () => {
    const swiperEls = document.querySelectorAll('[data-deals-swiper]');
    if (swiperEls.length < 1) {
        return;
    }
    swiperEls.forEach((swiperEl, index) => {
        const prevBtn = swiperEl.querySelector('.swiper-button-prev');
        const nextBtn = swiperEl.querySelector('.swiper-button-next');
        const swiperContainer = swiperEl.querySelector('.swiper');
        swiperContainer.id = `swiper-${index}`;
        const slidesFooter = swiperContainer.querySelectorAll('.card-tile-footer');
        const equalizeHeight = () => {
            slidesFooter.forEach((slideFooter) => {
                slideFooter.style.minHeight = '0px';
                const contentHeight = slideFooter.offsetHeight;
                slideFooter.style.minHeight = `${contentHeight}px`;
            });
        };
        equalizeHeight();
        const swiper = new Swiper(`#${swiperContainer.id}`, {
            simulateTouch: false,
            slidesPerView: 4,
            breakpoints: {
                639: {
                    slidesPerView: 1,
                },
                767: {
                    slidesPerView: 2,
                },
                1023: {
                    slidesPerView: 3,
                }
            },
            onSlideChangeStart: () => {
                prevBtn.classList.toggle('hide', swiper.isBeginning);
                nextBtn.classList.toggle('hide', swiper.isEnd);
            },
            onReachBeginning: () => prevBtn.classList.add('hide'),
            onReachEnd: () => nextBtn.classList.add('hide')
        });
        if (nextBtn && prevBtn) {
            nextBtn.addEventListener('click', () => swiper.slideNext());
            prevBtn.addEventListener('click', () => swiper.slidePrev());
        }
        window.addEventListener('resize', () => {
            swiper.slideTo(0);
            equalizeHeight();
        });
    });
};
export default specialOffers;
$(document).ready(function() {
    let modalHtml = '';
    $(document).on('click', '.promoCopy, .promoCopyTopPicks', function() {
        let copyText = $(this).attr('data-attr-copy');
        let clipBoardElem = document.createElement('input');
        document.body.appendChild(clipBoardElem);
        clipBoardElem.value = copyText;
        clipBoardElem.select();
        navigator.clipboard.writeText(clipBoardElem.value);
        document.execCommand('copy');
        document.body.removeChild(clipBoardElem);
    });
    $(document).on('click', '.promoInfoTopPicks', function() {
        let modalId = $(this).attr('data-target');
        modalHtml = $('#modal' + modalId).html();
        $('#modal' + modalId).html('');
        $('<div id="viewModal' + modalId + '">' + modalHtml + '</div>').appendTo('body');
        $('#' + modalId).modal('show');
    });
    $(document).on('click', '.closeModalTopPicks', function() {
        let modalId = $(this).attr('data-target-id');
        $('#viewModal' + modalId).modal('hide');
        $('#viewModal' + modalId).remove();
        $('body').removeClass('modal-open');
        $('body').css('');
        $('#modal' + modalId).html(modalHtml);
    });
    const equaliseFeaturedDealsCardHeights = () => {
        const rows = document.querySelectorAll('.swiper-wrapper');
        const selectors = [
            '.card-tile-title', '.card-tile-feefo', '.handset-wrapper', '.card-tile-promo'
        ];
        const applyHeights = (nodes) => {
            if (window.innerWidth < 768) {
                return nodes.forEach(node => node.style.height = 'auto');
            }
            let maxHeight = 0;
            nodes.forEach((node) => {
                node.style.height = 'auto';
                if (node.offsetHeight > maxHeight) {
                    maxHeight = node.offsetHeight;
                }
            });
            nodes.forEach(node => node.style.height = `${maxHeight}px`);
        };
        const init = () => rows.forEach(row =>
            selectors.forEach(selector =>
                applyHeights(row.querySelectorAll(selector))
            )
        );
        window.removeEventListener('resize', debounce(() => init()));
        window.addEventListener('resize', debounce(() => init()));
        window.addEventListener('load', init);
        init();
    };
    const reloadFeefoScript = () => {
        const old = document.querySelector('script[src*="feefo.com/api/javascript"]');
        if (old) {
            old.remove();
        }
        const s = document.createElement('script');
        s.src = 'https://api.feefo.com/api/javascript/carphone-warehouse';
        s.async = true;
        document.body.appendChild(s);
    };
    reloadFeefoScript();
    equaliseFeaturedDealsCardHeights();
    // CPW-5292 accordian start
    if ($('.discountAccordionHome').length) {
        $(document).on('show.bs.collapse hide.bs.collapse', '.collapse', function(e) {
            e.preventDefault();
        });
        $(document).on('click', '[data-toggle="collapse"]', function(e) {
            e.preventDefault();
            let target = $($(this).data('target'));
            let isOpen = target.hasClass('in');
            target.toggleClass('in');
            $(this).attr('aria-expanded', !isOpen);
        });
    }
    window.addEventListener('resize', debounce(() => equaliseFeaturedDealsCardHeights()));
    // CPW-5292 accordian end
});
